import React from 'react';
const stats = [{
  emoji: '📄',
  value: '300+',
  label: 'Pages'
}, {
  emoji: '🗂',
  value: '6 + Run of Show',
  label: 'Volumes'
}, {
  emoji: '💬',
  value: '348',
  label: 'Direction lines'
}, {
  emoji: '🎨',
  value: '200+ / 60+',
  label: 'Poses & diagrams'
}, {
  emoji: '⏱',
  value: 'Break points',
  label: 'For every part of the day'
}];
const coverage = ['Run of Show', 'Getting Ready', 'First Look', 'Ceremony', 'Family Formals', 'Couple Portraits', 'Reception'];
export function ProductReveal() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-234" data-mp="28fm2a1a49u4j">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-235" data-mp="2n2xgyc1lhu8v">
        <span className="inline-flex items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-[10px] uppercase tracking-[0.22em] text-ink-soft" data-id="element-236" data-mp="2n4iapzg3595o">
          📸 The complete direction system for wedding photographers
        </span>

        <h2 className="mt-8 font-serif text-4xl sm:text-6xl text-ink" data-id="element-237" data-mp="1pobgtzn5u9k1">Direct the Day™</h2>
        <p className="mx-auto mt-5 max-w-3xl font-serif text-xl italic sm:text-2xl text-gold-dark" data-id="element-238" data-mp="1b17cuhgzu2cv">
          6 Volumes + The Run of Show + 5 Field Bonuses — From Getting Ready to the
          Send-Off, in the Order It Actually Happens
        </p>

        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-239" data-mp="1jtsvlxkmk91p" />

        <p className="mx-auto mt-8 max-w-3xl text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-240" data-mp="1osm0j1luirq9">
          This is not a posing guide. Not a prompt deck. Not another Pinterest board with
          200 pins and zero words. It&rsquo;s the wedding day, scripted: 300+ pages of
          word-for-word direction, illustrated poses, printable shot lists and break-point
          timelines — covering all eight hours, not the twenty minutes a posing guide
          covers.
        </p>

        <ul className="mt-12 grid grid-cols-2 gap-px overflow-hidden border border-gold-soft bg-gold-soft sm:grid-cols-5" data-id="element-241" data-mp="2cig8b4rb5q3n">
          {stats.map(stat => <li key={stat.label} className="bg-ivory px-4 py-7" data-id="element-242" data-mp="2hj4ammkzltd6">
              <div aria-hidden="true" className="text-lg" data-id="element-243" data-mp="1rrkr6cejdvpu">
                {stat.emoji}
              </div>
              <div className="mt-2 font-serif text-lg text-ink" data-id="element-244" data-mp="1mszsihexnk3i">{stat.value}</div>
              <div className="mt-1 text-[11px] uppercase tracking-[0.14em] text-ink-muted" data-id="element-245" data-mp="21q0ioghh76zv">
                {stat.label}
              </div>
            </li>)}
        </ul>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-2.5" data-id="element-246" data-mp="191uz3x25ro1m">
          {coverage.map(item => <li key={item} className="rounded-full border border-ink/10 px-4 py-1.5 text-xs tracking-wide text-ink-soft" data-id="element-247" data-mp="144clhtd74kna">
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}